// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".update-probe-check-modal .el-dialog__header button {\n  display: none;\n}\n.update-probe-check-modal .el-dialog__body {\n  padding-top: 0;\n}\n.update-probe-check-modal .el-dialog__body .modal-title {\n  padding-bottom: 20px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
